import { render, staticRenderFns } from "./DataTeam.vue?vue&type=template&id=4fa37058&scoped=true&"
import script from "./DataTeam.vue?vue&type=script&lang=js&"
export * from "./DataTeam.vue?vue&type=script&lang=js&"
import style0 from "./DataTeam.vue?vue&type=style&index=0&id=4fa37058&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa37058",
  null
  
)

export default component.exports